import React from 'react';
import { Helmet } from "react-helmet";

const PageHelmet = ({ pageTitle }) => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta name="robots" content="index, follow" />
                <title>{pageTitle} - Dsider</title>
                <meta name="description" content="Our AI-driven software divowers real-time decision-making in the Energy sector, ensuring precision, efficiency, and lasting value from strategy to operations." />
            </Helmet>
        </>
    );
};

export default PageHelmet;